export default "__VITE_ASSET__DBDwegaf__"